export const DELAY = 'delay';
export const ACTION_TYPE = 'actionType';
export const DIRECTION = 'direction';